import FilterSearch from '../../_partials/filter-search/filter-search';

export default class Who {

  constructor() {
    this.filterSearch = document.querySelector('.filter-search');
    this.tabs = document.querySelector('.tabs');
    this.tabButtonAll = document.querySelectorAll('.tabs__button');
    this.who = document.querySelector('.who');
    this.tabContent = document.querySelectorAll('.who__content');
    this.whoOrganizationForm = document.querySelector('.who__organization-form');
    this.whoFilters = document.querySelector('.who__filters');
    this.whoSelect = document.querySelector('.who__select');
    this.searchInput = document.querySelector('.search-field__input');
    this.searchCloseButton = document.querySelector('.search-field__button--close');
  }

  _removeActive() {
    [...this.tabButtonAll].map(item => {
      item.classList.remove('tabs__button--active');
    });
    [...this.tabContent].map(item => {
      item.classList.remove('who__content--active');
    });
  }

  _activeFilterButton() {
    [...document.querySelectorAll('.who__button')].map(item => {
      item.classList.remove('who__button--active');
    });
  }

  _activeTab(event) {
    this._removeActive();

    const currentTarget = event.target.closest('.tabs__button');
    currentTarget.classList.add('tabs__button--active');

    const activePaneId = currentTarget.getAttribute('data-tab'),
      activePane = this.who.querySelector(activePaneId);
    activePane.classList.add('who__content--active');
  }

  _createFilters() {
    [...this.whoSelect.options].map((option, i) => {
      const createFiltersButton = document.createElement('button');
      createFiltersButton.setAttribute('class', 'button who__button');
      createFiltersButton.innerHTML = option.innerHTML;

      option.selected
        && createFiltersButton.classList.add('who__button--active');

      createFiltersButton.addEventListener('click', () => {
        option.selected = createFiltersButton;
        this._activeFilterButton();
        createFiltersButton.classList.add('who__button--active');
      });

      this.whoFilters.appendChild(createFiltersButton);
    });
  }

  init() {

    this._createFilters();

    this.filterSearch
      && new FilterSearch(this.whoOrganizationForm);

    if (this.who) {
      this.tabs.addEventListener('click', e => {
        e.target.closest('.tabs__button') === null
          ? e.stopPropagation()
          : this._activeTab(e);
      });
    }

    if (this.searchCloseButton) {
      this.searchCloseButton.addEventListener('click', () => {
        this.searchInput.value = '';
      });
    }

  }
}